import { JOBS_URL } from '@/utils/constants'

const INSPECTIONS = () => `${JOBS_URL}`
const INSPECTIONS_BY_ID = (id: string) => `${JOBS_URL}/${id}`

export default {
  INSPECTIONS,
  INSPECTIONS_BY_ID
}
